// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3IQ3C","info":"Note_info__2Mud7","note":"Note_note__27QEk","actions":"Note_actions__2RScF"};